'use client'

import React from 'react'

import { FeaturedCarouselType } from '~/app/common/enums'
import { useTranslation } from '~/app/i18n/client'
import { FeaturedCarousel } from '../featured-carousel/featured-carousel'
import { useApi } from '../hooks/use-api'
import { useRecommendedItems } from '../hooks/use-recommeded-items'

export type RecommendedItemsProps = {
  content: {
    id: string
    numberOfResults?: number
    minScore?: number
    recommendationType?: 'general' | 'also_viewed' | 'best_sellers'
    filterType?: string
    filterValues?: string
    boostStrategyId?: string
    boostStrategyValues?: string
    boostInfluencePercent?: number
    title: string
    helperText?: string
  }
}

const RecommendedItems: React.FC<RecommendedItemsProps> = ({
  content,
}: RecommendedItemsProps) => {
  const { tenant } = useApi()
  const { t: translate } = useTranslation()

  const { items, loading } = useRecommendedItems({
    numberOfResults: content?.numberOfResults,
    minScore: content?.minScore,
    recommendationType: content?.recommendationType,
    filterType: content?.filterType,
    filterValues: content?.filterValues,
    boostStrategyId: content?.boostStrategyId,
    boostStrategyValues: content?.boostStrategyValues,
    boostInfluencePercent: content?.boostInfluencePercent,
  })

  if (!tenant?.flags?.recommendedItems || (!loading && !items?.length)) {
    return null
  }

  return (
    <div className="col-span-2 mt-8">
      <FeaturedCarousel
        type={FeaturedCarouselType.Product}
        title={content?.title ?? translate('featuredProducts')}
        helperText={content?.helperText ?? ''}
        items={items}
        loading={loading}
        listName="recommended-items-carousel"
      />
    </div>
  )
}

export { RecommendedItems }
